<template>
  <div class="form-row">
    <form class="col-sm-10 p-4">
      <div class="form-group col-sm-12 mb-sm-0 h6">
        <label class="font-weight-bold">Candidate Name:</label>
        <label>{{ fullName(candidate) }}</label>
      </div>

      <div class="form-group col-sm-12 mb-sm-0 h6">
        <label class="font-weight-bold">Date of Birth:</label>
        <label>{{ candidate.date_of_birth }}</label>
      </div>

      <div class="form-group col-sm-12 mb-sm-0 h6" v-if="applicantSearch.currentAddress">
        <label class="font-weight-bold">Address:</label>
        <label>{{ applicantSearch.currentAddress.address }}</label>

      </div>
      <template>
        <div class="container">
          <div class="row">
            <div
                v-for="license in filteredLicenses"
                :key="license.id+'_'+license.type"
                class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mb-3"
            >
              <div class="card p-3 shadow-sm rounded">
                <div class="card-body">
                  <h6 class="font-weight-bold">License Number:</h6>
                  <p>{{ license.number }}</p>

                  <h6 class="font-weight-bold">Type:</h6>
                  <p>{{ license.type }}</p>

                  <h6 class="font-weight-bold">Expiry:</h6>
                  <p>{{ formatDate(license.expiry) }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>

      <div class="form-group col-sm-12 ml-sm-4 mt-sm-2">
        <p class="fontStyle">Using candidate SIA license number or other required information search SIA holders
          register
          and verify license validity</p>
      </div>
      <hr>
      <div class="row mt-sm-4">
        <div class="form-group col-sm-4 mt-sm-3">
          <el-button class="btn btn-primary el-button--default col-sm-12"
                     @click.prevent="openLink()">
            Check SIA Register
          </el-button>
        </div>
        <div class="form-group col-sm-6">
          <label>CHECKED</label>
          <app-input type="radio"
                     :list="yesOrNoList"
                     v-model="siaLicenseCheck.result_status"/>
        </div>
      </div>
      <div class="row mt-sm-2">
        <document-table :documents="filesForDocumentTable"
                        @onDelete="onTableDelete"
        />
      </div>
      <div class="row">
        <upload-btn :fileObj="siaLicenseCheck"
                    :renderType="type.Search"
                    :emailAddress="candidate.email"
                    :searchDocument="documentObj"
                    :filesForDocumentTable="filesForDocumentTable"
                    :metaData="{
                      ...siaLicenseCheck,
                      statusable_type: statusAble.statusable_type,
                      id: statusAble.statusable_id
                    }"
                    :error="error"/>
        <div class="form-group col-sm-12">
          <p class="col-sm-6 fontStyle errorStyle"
             v-if="error.isError">
            {{ error.errorMessage }}
          </p>
        </div>
      </div>
      <div class="row mt-sm-2">
        <div class="form-group col-sm-12">
          <label>Results Matched:</label>
          <app-input type="radio"
                     :list="yesOrNoList"
                     v-model="siaLicenseCheck.result_matched"/>
        </div>
      </div>
      <div class="form-group col-sm-12">

        <label for="Date">Select Date</label>
        <app-input
            class="col-sm-6"
            type="date"
            v-model="siaLicenseCheck.statusDate"
            :initialValue="new Date()"
        />
      </div>
      <div class="row mt-sm-2">
        <div class="form-group col-sm-4 mt-sm-3">
          <el-button class="btn btn-primary el-button--default col-sm-12"
                     @click="submitBtn">
            Submit
          </el-button>
        </div>
      </div>

    </form>
    <form class="col-sm-2">
      <drawer-component title="Comments"
                        size="40%">
        <general-comments :comments="comments"
                          :applicantId="candidate.id"
                          :statusable_type="statusAble.statusable_type"
                          :statusable_id="statusAble.statusable_id"/>
      </drawer-component>
    </form>
  </div>
</template>

<script>
import {_yesOrNoList, siaLicenseURL} from '@Views/Screening/utility/constant';
import {fullName, pushFileInDocumentTable, saveScreeningSearch} from "@Views/Screening/utility/common";
import {searchType} from "@Views/Screening/utility/enums";
import {FormMixin} from "@/core/mixins/form/FormMixin";
import {uploadBtnRenderType} from '@Views/Screening/utility/enums';

export default {
  name: "SIALicenseCheck",
  mixins: [FormMixin],
  data() {
    return {
      applicantSearch: this.$attrs['props'].applicantSearch,
      candidate: this.$attrs['props'].candidate,
      currentAddress: this.$attrs['props'].currentAddress??{},
      yesOrNoList: _yesOrNoList,
      siaLicenseCheck: {
        search_type: searchType.SIA,
        files: []
      },
      comments: [],
      statusAble: {},
      filesForDocumentTable: [],
      documentObj: {},
      error: {
        isError: false,
        errorMessage: ''
      },
      type: uploadBtnRenderType
    }
  },
  computed: {
    filteredLicenses() {
      return this.candidate.licenses.filter(license =>
          !["DrivingLicense", "Others", "Frontline"].includes(license.type)
      );
    }
  },
  created() {
    this.$hub.$on('pass-steps-in-search-case', (data) => {
      if (data) {
        this.applicantSearch[searchType.SIA][0].screening_status.push(data);
      }
    });
  },
  mounted() {
    this.setPropsIntoObject();
  },
  methods: {
    formatDate(date) {
      return new Date(date).toLocaleDateString(); // Formats the date nicely
    },
    fullName,
    pushFileInDocumentTable,
    saveScreeningSearch,
    openLink() {
      window.open(siaLicenseURL, '_blank');
    },
    submitBtn() {
      this.saveScreeningSearch(this.candidate.id, this.siaLicenseCheck);
    },
    setPropsIntoObject() {
      const sia = this.applicantSearch[searchType.SIA][0];
      this.$set(this.siaLicenseCheck, 'result_matched', sia.result_matched === 0 ? 'no' : 'yes');
      this.$set(this.siaLicenseCheck, 'result_status', sia.result_status === 0 ? 'no' : 'yes');
      this.$set(this.siaLicenseCheck, 'statusDate', sia.updated_at);

      this.$set(this.statusAble, 'statusable_type', sia.statusable_type);
      this.$set(this.statusAble, 'statusable_id', sia.id);
      if (sia.screening_status.length > 0) {
        this.comments.push(...sia.screening_status);
      }
      if (sia.applicant_files.length > 0) {
        let index = 0;
        for (const file of sia.applicant_files) {
          this.$set(this.filesForDocumentTable, index, {
            id: file.id,
            name: file.file_name,
            fileURL: `/${file.file_path}`,
            uploaded_on: file.created_at
          });
          index++;
        }
      }
    },
    onTableDelete (index) {
      this.applicantSearch[searchType.SIA][0].applicant_files.splice(index, 1);
    }
  },
  watch: {
    documentObj: {
      handler: function () {
        if (this.documentObj.file) {
          this.pushFileInDocumentTable(this.documentObj.file);
          const {name, fileURL, ...rest} = this.documentObj.file;
          this.applicantSearch[searchType.SIA][0].applicant_files.push(rest);
          this.submitBtn();
        }
      },
      deep: true
    }
  }
}
</script>

<style scoped>
.fontStyle {
  font-size: 12px;
}

.errorStyle {
  font-weight: bolder;
  color: red;
}

 .card {

   background: #fff;
   border-radius: 10px;
   transition: 0.3s ease-in-out;
 }
 .card-body{
   padding: 0 !important;
 }

.card:hover {
  transform: translateY(-3px);
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
}

h6 {
  margin-bottom: 5px;
  color: #333;
}

p {
  margin-bottom: 10px;
  font-size: 14px;
  color: #555;
}

</style>